<template>
	<div class="Index">
		<div class="search">
			<div class="location" @click="selectCity">
				<span>上海</span>
				<van-icon name="arrow-down" />
			</div>
			<div class="search-input">
				<van-icon name="search" />
				<input type="text" placeholder="搜索内容" @focus="goSearch">
			</div>
		</div>
		<banner :type="type"></banner>
		<div class="modules1">
			<a :href="item.path" v-for="(item,index) in modules" :key="index">
				<img :src="item.src" alt="">
				<span>{{item.name}}</span>
			</a>
		</div>
		<div class="hr-7"></div>
		<!-- 专栏推荐 -->
		<div class="recommendColumn">
			<div class="head">
				<h3>专栏推荐</h3>
				<div @click="changeBatches"> 
					<!-- <transition name="roate"> -->
					  <van-icon name="replay" :class="rotateLoading?'rotate-active':''"/>
					<!-- </transition> -->
				换一批</div>
			</div>
			<div class="content">
				<div class="column-item" v-for="(item,index) in columnsList" :key="index" @click="skipColumnDetails(item.id)">
					<div class="status" @click="followColumn(item.id,index)" @click.stop v-if="item.is_follow==0">
						<van-icon name="plus" />关注
					</div>
					<div class="status" @click="followColumn(item.id,index)" @click.stop v-if="item.is_follow==1">
						<van-icon name="success" />取消关注
					</div>					
					<img :src="item.banner" alt="">
				</div>
			</div>
		</div>
		<!-- 文章推荐 -->
		<div class="recommendArticle" v-if="articlesList.length!=0">
			<div class="head">
				<h3>文章推荐</h3>
			</div>
			<div class="content">
				<row-item-list  :list="articlesList"></row-item-list>
			</div>
		</div>

		<tabbar :active="index"></tabbar>
	</div>
</template>
<script>
import axios from 'axios'
	import Banner from "../components/Banner.vue";
    import Tabbar from '../components/Tabbar.vue';
    import RowItemList from "../components/RowItemList.vue"
    import {ModulesRecommend,ColumnChangeBatches,ColumnFollow} from "../config/interface.js"
	export default{
		components:{
			Banner,
    		Tabbar,
			RowItemList
		},
		data(){
			return{
				show:true,
				type:6,
				index:0,           //tabbar的index
				articlesList:[],   //文章列表
				columnsList:[],    //专栏列表
				rotateLoading:false,        //换一批的icon状态
				swiperOption: {
					direction: 'horizontal',
	                loop: true,
	                autoplay: 3000,
	                slidesPerView: "auto",
	                centeredSlides:true,
	                spaceBetween: 10,
			        pagination: {
			            el: '.swiper-pagination',
			            clickable: true
			        }
        		},
        		modules:[
        			{
        				src:require('../assets/images/Index/informationModule.png'),
        				name:'前沿资讯',
        				path:'/information/index'
        			},
        			{
         				src:require('../assets/images/Index/meetingModule.png'),
        				name:'会议',
        				path:'/meeting/index'       				
        			},
 					{
         				src:require('../assets/images/Index/columnModule.png'),
        				name:'专栏',
        				path:'/column/index'						
 					},
 					{
         				src:require('../assets/images/Index/caseModule.png'),
        				name:'病例',
        				path:'/case/index'					
					 },
 					// {
        			// 	src:require('../assets/images/Index/instrumentModule.png'),
        			// 	name:'器械百科',
        			// 	path:'/instrument/index'						
					//  },
					//  {
        			// 	src:require('../assets/images/Index/toolModule.png'),
        			// 	name:'评分工具',
        			// 	path:'http://vimarking.edr120.com/mobile/home/list'						
 					// },	
					 {
        				src:require('../assets/images/Index/guideModule.png'),
        				name:'指南/共识',
        				path:'/guide' 
					 }					    			
        		],   //模块
			}
		},
		mounted(){
			// window.getApp = this;
			
			this.getRecommendArticles();
			this.changeBatches();
		},
		watch:{
			    '$store.state.Loading':(newVal,oldVal)=>{
			      	this.loading=newVal;
			    }			
		},
		methods:{
			//换一批
			changeBatches(){
				this.rotateLoading=true;
				const url=ColumnChangeBatches;
				let params={};
				const method='POST';
				fetch(url,params,method,true)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.columnsList=data;
						setTimeout(()=>{
							this.rotateLoading=false;
						},1000)

					}
				})
			},
			//跳转专栏详情
			skipColumnDetails(id){
				this.$router.push({
					path:'/column/details',
					query:{
						id:id
					}
				})
			},
			//关注专栏
			followColumn(id,index){
				const url=ColumnFollow;
				const method='POST';
				let params={
					column_id:id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let attach=res.data.attach;
						this.columnsList[index].is_follow=attach;
						
					}
				})
			},
			//文章推荐
			getRecommendArticles(){
				this.$store.dispatch('isShowLoading',true);
				const url=ModulesRecommend;
				const method='POST';
				let params={
					module_id:7
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.articlesList=data;
					}
					this.$store.dispatch('isShowLoading',false);
				})

			},
			//去搜索
			goSearch(){
				this.$router.push({path:'search/search'})
			},
			//去选择城市
			selectCity(){
				
				this.$router.push({path:'/city/city'})
			}
		}
	}
</script>
<style lang="scss">
	.Index{
		/*动画*/
		.rotate-active{
			animation: rotate-in 1s;
		}
		@keyframes rotate-in{
			0%{
				transform: rotate(0);
			}
			100%{
				transform: rotate(360deg);
			}
		}
		/*搜索*/
		.search{
			padding:8px 12px;
			@include flex(row);
			align-items:center;
			justify-content:space-between;
			.location{
				color:#666;
				font-size:16px;
				margin-right:6px;
				span{
					margin-right:5px;
				}
			}
			.search-input{
				@include flex(row);
				align-items:center;				
				flex:1;
				background: #F2F2F2;
				border: 1px solid #BFBFBF;
				border-radius: 16px;
				height:32px;
				padding:0 20px;
				i{
					font-size:20px;
					color:#999;
				}
				input{
					flex:1;
					font-size:14px;
					color:#999;
					height:100%;
					padding-left:10px;
					background:transparent;
					border:0px;
				}
			}
		}
		/*轮播图*/
		.swiper-container{
			.swiper-slide{
				width:320px;
				height:150px;
			}

			img{
				border-radius:5px;
				width:100%;
				height:100%;
			}
		}
		/*模块*/
		.modules1{
			margin:10px 0;
			padding:0 10px;
			a{
				display:inline-block;
				width:25%;
				text-align:center;
				img{
					display:block;
					height:35px;
					margin:10px auto;
				}
				span{
					font-size: 13px;
					color: #090909;
					letter-spacing: 0.46px;
				}
			}
		}
		.head{
			height:50px;
			line-height:50px;
			h3{
			font-size: 17px;
			color: #090909;
			letter-spacing: 0.6px;
			}	
		}
		/*专栏推荐*/
		.recommendColumn{
			padding:0 12px;
			.head{
				@include flex(row);
				justify-content:space-between;
				align-items:center;
				div{
					/*width:57px;*/
					padding:0px 5px;
					height:25px;
					line-height:23px;
					text-align:center;
					border: 1px solid #C1C1C1;
					border-radius: 2px;
					font-size: 13px;
					color: #901D22;
					letter-spacing: 0.46px;
					i{
						vertical-align:-2px;
					}

				}
			}
			.content{
				@include flex(row);
				justify-content:space-between;
				.column-item{
					position:relative;
					width:170px;
					height:85px;
					img{
						position:absolute;
						width:100%;
						height:100%;
					}
					.status{
						padding:0px 5px;
						height:22px;
						line-height:22px;
						position:absolute;
						z-index:2;
						top:5px;
						right:5px;
						background: rgba(144,29,34,.8);
						border-radius: 2px;
						font-size: 12px;
						color: #FFFFFF;
						letter-spacing: 0.49px;
						.van-icon{
							vertical-align:-0.5px;
							margin-right: 2px;
						}
					}
				}
			}
		}
		
		/*文章推荐*/
		.recommendArticle{
			padding:0 12px;
			padding-bottom:55px; 
			margin-top:10px;
			.head{
				height:30px;
				line-height:30px;
			}
		}	
		


	}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue